module.exports = __webpack_public_path__ + "img/eu.c3050ef4.svg";